const sliderInit = () => {
    // Cache DOM query to avoid repeated calls
    const sliderBanners = document.querySelectorAll('.gg-slider-banner');
    if (sliderBanners.length === 0 || typeof Swiper === "undefined") {
        return;
    }

    // Cache quote content slider query (used in multiple places)
    const quoteContentSlider = document.querySelector('.gg-quote-content-slider');
    const focusableElements = 'button, a, input, select, textarea';

    sliderBanners.forEach((module) => {
        const nextButton = module.querySelector('.swiper-button-next');
        const prevButton = module.querySelector('.swiper-button-prev');
        const sliderInitElement = module.querySelector('.gg-init-slider');
        const buttonsSlider = module.querySelector('.gg-buttons-slider');
        const sliderAutoPlayEnabled = module
            .querySelector('.gg-slider-banner__container')
            .getAttribute('slider-auto-speed');
        const sliderAutoPlayEnabledSpeed = sliderAutoPlayEnabled ? parseInt(sliderAutoPlayEnabled) : 0;
        const autoPlay = {
            delay: sliderAutoPlayEnabledSpeed,
            disableOnInteraction: false,
        };

        if (sliderInitElement) {
            const debounce = (func, delay) => {
                let timeoutId;
                return (...args) => {
                    clearTimeout(timeoutId);
                    timeoutId = setTimeout(() => {
                        func.apply(this, args);
                    }, delay);
                };
            };

            const setTabIndex = (swiper) => {
                const bannerSlides = module.querySelectorAll('.swiper-slide');
                bannerSlides.forEach((element) => {
                    const tabIndex = element.classList.contains('swiper-slide-active') ? 0 : -1;
                    element.querySelectorAll(focusableElements).forEach((element) => (element.tabIndex = tabIndex));
                });
            };

            // eslint-disable-next-line no-undef
            const swiper = new Swiper(sliderInitElement, {
                direction: 'horizontal',
                allowTouchMove: true,
                autoHeight: true,
                loop: true,
                slidesPerView: 1,
                autoplay: sliderAutoPlayEnabled ? autoPlay : false,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
            });

            // Set up tab index callbacks after Swiper is initialized
            const setTabIndexCallback = () => setTabIndex(swiper);
            swiper.on('afterInit', setTabIndexCallback);
            swiper.on('slideChangeTransitionEnd', setTabIndexCallback);

            const createYouTubeIframe = (videoBox) => {
                if (!videoBox.querySelector('iframe')) {
                    const dataVideo = videoBox.getAttribute('data-video-id');
                    if (dataVideo) {
                        const iframe = document.createElement('iframe');
                        iframe.className = 'gg-slider-banner__slide__video-youtube__video';
                        iframe.src = `https://www.youtube.com/embed/${dataVideo}`;
                        iframe.title = '';
                        iframe.frameBorder = '0';
                        iframe.allow =
                            'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
                        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
                        iframe.allowFullscreen = true;
                        videoBox.appendChild(iframe);
                    }
                }
            };

            const deleteExistingOverlays = (videoBox) => {
                const existingOverlays = videoBox.querySelectorAll(
                    '.gg-slider-banner__slide__video-youtube__overlay',
                );
                existingOverlays.forEach((overlay) => {
                    videoBox.removeChild(overlay);
                });
            };

            const deleteExistingUrlParams = (videoBox) => {
                const iframes = videoBox.querySelectorAll('iframe');
                iframes.forEach((iframe) => {
                    if (iframe.src.includes('?')) {
                        const src = iframe.src.split('?')[0];
                        iframe.src = src;
                    }
                });
            };

            const createNewOverlay = (videoBox) => {
                const overlay = document.createElement('div');
                overlay.className = 'gg-slider-banner__slide__video-youtube__overlay';
                const posterSrc = videoBox.getAttribute('data-poster');
                if (posterSrc) {
                    overlay.style.backgroundImage = `url(${posterSrc})`;
                }

                videoBox.appendChild(overlay);

                overlay.addEventListener('click', (event) => {
                    swiper.autoplay.stop();
                    const iframe = event.target
                        .closest('.gg-slider-banner__slide__video-youtube')
                        .querySelector('iframe');
                    if (iframe && iframe.tagName.toLowerCase() === 'iframe') {
                        overlay.remove();
                        iframe.src += '?autoplay=1&mute=1';
                    }
                });
            };

            const initYouTubeVideo = () => {
                module.querySelectorAll('.gg-slider-banner__slide').forEach((slide) => {
                    const videoElement = slide.querySelector('.gg-slider-banner__slide__video-youtube');
                    if (!videoElement) return;

                    if(sliderAutoPlayEnabled) swiper.autoplay.start();

                    deleteExistingOverlays(videoElement);

                    deleteExistingUrlParams(videoElement);

                    createNewOverlay(videoElement);

                    createYouTubeIframe(videoElement);
                });
            };

            const updateButtonsSliderPosition = () => {
                const buttonsSliderHeight = buttonsSlider.clientHeight;
                setTimeout(() => {
                    const activeSlide = module.querySelector('.swiper-slide-active');
                    if (activeSlide) {
                        const picture = activeSlide.querySelector('.gg-slider-banner__slide > picture');
                        if (picture) {
                            const pictureHeight = picture.offsetHeight;
                            if (window.innerWidth > 1024) {
                                buttonsSlider.style.top = pictureHeight + 2 + 'px';
                            } else {
                                buttonsSlider.style.top = (pictureHeight - buttonsSliderHeight) + 'px';
                            }
                        }
                    }
                }, 100);
            };

            swiper.on('slideChange', initYouTubeVideo);

            // Use cached query result instead of querying again
            if (quoteContentSlider !== null && buttonsSlider) {
                swiper.on('slideChange', updateButtonsSliderPosition);
                // Store handler reference for cleanup
                const resizeHandler = updateButtonsSliderPosition;
                window.addEventListener('resize', resizeHandler);
                updateButtonsSliderPosition();

                // Store cleanup function on swiper instance for potential cleanup
                if (swiper && typeof swiper.destroy === 'function') {
                    const originalDestroy = swiper.destroy;
                    swiper.destroy = function() {
                        window.removeEventListener('resize', resizeHandler);
                        originalDestroy.call(this);
                    };
                }
            }

            initYouTubeVideo();
        }
    });
};

sliderInit();

if (window.acf) {
    window.acf.addAction('render_block_preview/type=slider', sliderInit);
}
